import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Button} from 'react-bootstrap';
import classnames from 'classnames';
import dayjs from 'dayjs';
import {DataItemTextareaInput} from '../../../_common/components/DataItemTextarea';
import MatchedInvoicesGrid from './MatchedInvoicesGrid';
import {MatchedInvoicesRow} from '../../types';
import styles from './styles.module.scss';

interface ViewMatchedInvoicesForm extends MatchedInvoicesRow {
  closeModal: () => void;
}

export const ViewMatchedInvoicesForm = ({
                                          id,
                                          createdAt,
                                          amount,
                                          description,
                                          matchedInvoices,
                                          closeModal
                                        }: ViewMatchedInvoicesForm) => {
  const prefix = 'bankStatements-matchedInvoices-popup';
  return (
    <div key={id}>
      <h3 className="card-title font-weight-bold text-dark text-center mb-2">
        <FormattedMessage id={`${prefix}-header`} defaultMessage="Matched Invoices"/>
      </h3>
      <div className={styles.generalDetails}>
        <div className={styles.generalDetailsItem}>
          <div className={styles.label}>
            <FormattedMessage id={`${prefix}-createdAt`} defaultMessage="Created at"/>
          </div>
          <div className={classnames(styles.field, 'mb-1')}>
            <DataItemTextareaInput
              value={dayjs(createdAt).format('DD-MM-YYYY')}
              disabled={true}
            />
          </div>
        </div>
        <div className={styles.generalDetailsItem}>
          <div className={styles.label}>
            <FormattedMessage id={`${prefix}-amount`} defaultMessage="Amount"/>
          </div>
          <div className={styles.field}>
            <DataItemTextareaInput
              value={amount}
              disabled={true}
            />
          </div>
        </div>
        <div className={styles.generalDetailsItem}>
          <div className={styles.label}>
            <FormattedMessage id={`${prefix}-description`} defaultMessage="Description"/>
          </div>
          <div className={styles.field}>
            <DataItemTextareaInput
              value={description}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <MatchedInvoicesGrid rows={matchedInvoices} tableRowID={id}/>
      <div className="d-flex justify-content-center mt-6">
        <Button
          className="btn-secondary btn-sm mx-2 w-120px"
          onClick={closeModal}
        >
          <FormattedMessage id={`${prefix}-cancel`} defaultMessage="Cancel"/>
        </Button>
      </div>
    </div>
  );
};
